import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['smsCheckbox'];

  toggle(event) {
    // Strip non-numeric characters to match server-side validation (\A\d*\z)
    event.target.value = event.target.value.replace(/\D/g, '');
    const hasExtension = event.target.value.trim() !== '';
    if (this.hasSmsCheckboxTarget) {
      this.smsCheckboxTarget.disabled = hasExtension;
      if (hasExtension) {
        this.smsCheckboxTarget.checked = false;
      }
    }
  }
}
